import React from 'react'

export default function N3view() {
  return (
    <div>
     This is user´s specific which displays the user´s defined view and can be accessed without logging in
    </div>
  )
}
